export const TEXTS = {
  START_INFO: 'Você pode fazer o download de um arquivo de exemplo ',
  END_INFO: ' Para mais instruções de uso, consulte o arquivo.'
};

export const URLS = {
  SPREADSHEET:
    'https://docs.google.com/spreadsheets/d/1bIQLB9fHgifm6Z8CNMde6AtT0mfI_fn3Lhj-htFCOL0'
};
